<template>
	<div class="certificate-list">
		<b-card header-tag="header" footer-tag="footer" class="hidden-print">
			<transition name="slide" mode="out-in">
				<div class="filter-frame bg-light p-2">
					<b-row v-if="isKorzinka"/>
					<b-row v-else-if="!isErrorSales">
						<b-col sm="2">
							<b-input-group size="sm">
								<date-picker
									v-model="fromDate"
									lang="ru"
									:placeholder="$t('certificate.fromDate')"
									value-type="format"
									format="DD-MM-YYYY"
								></date-picker>
							</b-input-group>
						</b-col>
						<b-col sm="2">
							<b-input-group size="sm">
								<date-picker
									v-model="toDate"
									lang="ru"
									:placeholder="$t('certificate.toDate')"
									value-type="format"
									format="DD-MM-YYYY"
								></date-picker>
								<!--<masked-input v-model="toDate"-->
								<!--mask="11-11-1111"-->
								<!--id="toDate"-->
								<!--class="ml-1 form-control form-control-sm"-->
								<!--:placeholder="$t('certificate.toDate')"/>-->
								<!--<b-input-group-addon>-->
								<!--<b-button size="sm" disabled>-->
								<!--<i class="fa fa-calendar"></i>-->
								<!--</b-button>-->
								<!--</b-input-group-addon>-->
							</b-input-group>
						</b-col>
						<b-col sm="3">
							<multiselect
								v-model="selectedDepartment"
								v-if="isSales || isSalesByItem"
								:options="getDepartmentsLocal()"
								:multiple="true"
								:group-select="true"
								track-by="id"
								label="name"
								:show-labels="false"
								:allow-empty="true"
								class="multiselect-pricing"
							>
								<span
									slot="noResult">Oops! No elements found. Consider changing the search query.</span>
							</multiselect>
							<multiselect
								v-model="zReportDep"
								v-else
								@input="fetchCashboxList"
								:options="myDepartments"
								:multiple="false"
								:group-select="true"
								track-by="id"
								label="name"
								:show-labels="false"
								:allow-empty="true"
								class="multiselect-pricing"
							>
								<span
									slot="noResult">Oops! No elements found. Consider changing the search query.</span>
							</multiselect>
						</b-col>
						<b-col v-if="isSales || isSalesByItem" cols="3">
							<multiselect
								:group-select="true"
								:show-labels="false"
								:allow-empty="true"
								class="multiselect-pricing"
								v-model="cashboxSaleId"
								:plain="false"
								:options="cashboxSaleList"
								:multiple="false"
								size="sm"
								label-for="Position"
								:required="true"
								track-by="id"

								label="name"
							>
								<template slot="first">
									<option :value="null" disabled>
										--{{ $t('posSettings.selectMessage') }}--
									</option>
								</template>
							</multiselect>
						</b-col>
						<b-col cols="3" v-else>
							<multiselect
								:group-select="true"
								:show-labels="false"
								:allow-empty="true"
								class="multiselect-pricing"
								v-model="cashboxId"
								:plain="false"
								:options="cashboxList"
								:multiple="false"
								size="sm"
								label-for="Position"
								:required="true"
								track-by="id"

								label="name"
							>
								<template slot="first">
									<option :value="null" disabled>
										--{{ $t('posSettings.selectMessage') }}--
									</option>
								</template>
							</multiselect>
						</b-col>
						<b-col sm="2" v-if="isSales || isSalesByItem">
							<b-input-group>
								<b-form-input :placeholder="$t('sale.saleNumber')" v-model="saleNumber" type="text"></b-form-input>
							</b-input-group>
						</b-col>
						<!-- <b-col sm="3" v-if="!isCashier && isSales">
										<label for="input-small">
											{{$t('sidebar.sales.contragent')}}
										</label>
										<multiselect
											v-model="contrAgent"
											:options="contragents"
											track-by="id"
											:multiple="true"
											:group-select="true"
											:show-labels="false"
											:allow-empty="true"
											label="fullName"
											:placeholder="$t('sidebar.sales.contragent')"
											class="multiselect-pricing"
										>
										</multiselect>
						</b-col>-->
						<b-col sm="2" v-if="isSales || isSalesByItem">
							<b-form-select v-model="checkStatus">
<!--								<option value="PAID">{{ $t('sidebar.sales.ready') }}</option>-->
<!--								<option value="QARZGA">{{ $t('xAtchot.debt') }}</option>-->
<!--								<option value="HOMIYLIK">{{ $t('pos.sponsorship') }}</option>-->
								<option value="QAYTARISH">{{ $t('pos.return') }}</option>
								<template slot="first">
									<option :value="null">-- {{ $t('promo-to-product.status') }} --</option>
								</template>
							</b-form-select>
						</b-col>
						<b-col v-if="isSalesByItem" cols="3">
							<b-input-group>
								<b-form-input :placeholder="$t('incomes.create.product')" v-model="itemName" type="text"></b-form-input>
							</b-input-group>
						</b-col>
						<b-col v-if="isSalesByItem" cols="2">
							<b-input-group>
								<b-form-input :placeholder="$t('goods.special-barcode')" v-model="barcode" type="text"></b-form-input>
							</b-input-group>
						</b-col>
						<b-col v-if="isSalesByItem" cols="3">
							<b-input-group>
								<b-form-input :placeholder="$t('goods.barcode')" v-model="multiBarcode" type="text"></b-form-input>
							</b-input-group>
						</b-col>
						<b-col v-if="isSalesByItem" cols="2">
							<b-input-group>
								<b-form-input :placeholder="$t('goods.artikul')" v-model="artikul" type="text"></b-form-input>
							</b-input-group>
						</b-col>
						<b-col sm="1" :class="isSales ? 'pb-2' : 'pb-3' && isSalesByItem ? 'mt-2' : ''">
							<b-button variant="dark" @click="search">
								<span><i class="fa fa-search"></i></span>
							</b-button>
						</b-col>
						<b-col v-if="isSalesByItem" sm="2" class="mt-2">
							<b-form-select v-model="salesByItemLimit1">
								<option value="20">20</option>
								<option value="50">50</option>
								<option value="100">100</option>
								<option value="200">200</option>
								<option value="all">Все</option>
							</b-form-select>
						</b-col>
						<b-col v-else-if="isSales" sm="2">
							<b-form-select v-model="perPage1">
								<option value="20">20</option>
								<option value="50">50</option>
								<option value="100">100</option>
								<option value="200">200</option>
								<option value="all">Все</option>
							</b-form-select>
						</b-col>
					</b-row>
					<b-row v-else>
						<b-col>
							<multiselect v-model="errorSaleId" :options="errorSaleList" :custom-label="errorSaleLabel" :group-select="true" :show-labels="false" :allow-empty="true" :plain="false" :multiple="false" :required="true">
								<template slot="first">
									<option :value="null" disabled>
										--{{ $t('posSettings.selectMessage') }}--
									</option>
								</template>
							</multiselect>
						</b-col>
					</b-row>
				</div>
			</transition>
			<div slot="header" class="top-card">
				<span>
				  <h5 v-if="isSales">{{ $t('sidebar.sales.title') }}</h5>
				  <h5 v-else-if="isSalesByItem">Продажи по товарам</h5>
				  <h5 v-else-if="isZReports">{{ $t('zOtchet.list') }}</h5>
				  <h5 v-else-if="isErrorSales">Напечатанные продажи</h5>
				  <h5 v-else-if="isKorzinka">Корзина</h5>
				  <h5 v-else>{{ $t('zOtchet.list')+'*' }}</h5>
        		</span>
				<b-form-radio-group
					id="btn-radios-2"
					v-model="selected"
					buttons
					button-variant="outline-primary"
					size="sm"
					name="radio-btn-outline"
				>
					<template v-for="option in options">
						<b-form-radio :value="option.value" v-if="option.can">{{ option.text }}</b-form-radio>
					</template>
				</b-form-radio-group>
			</div>
			<div class="table-responsive table-wrapper">
				<table v-if="isSales" class="table table-bordered table-striped table-hover">
					<thead>
						<tr>
							<th class="text-center">№</th>
							<th class="text-center" style="cursor: pointer" @click="search('number')">{{ $t('sale.saleNumber') }} <i :class="sortBy.saleNumber===''?`fa fa-arrows-v`:sortBy.saleNumber==='asc'?'fa fa-arrow-up':sortBy.saleNumber==='desc'?'fa fa-arrow-down':'fa fa-arrows-v'" class="ml-2"/></th>
							<th class="text-center" style="cursor: pointer" @click="search('date')">{{ $t('sale.saleDate') }} <i :class="sortBy.saleDate===''?`fa fa-arrows-v`:sortBy.saleDate==='asc'?'fa fa-arrow-up':sortBy.saleDate==='desc'?'fa fa-arrow-down':'fa fa-arrows-v'" class="ml-2"/></th>
							<th class="text-center">{{ $t('sale.shopName') }}</th>
							<th class="text-center">{{ $t('POS №') }}</th>
							<th class="text-center">{{ $t('sale.status') }}</th>
							<th class="text-center">{{ $t('sale.kol-vo') }}</th>
							<th class="text-center">{{ $t('pos.sum') }}</th>
							<th class="text-center">{{ $t('sale.sum-skidka') }}</th>
							<th class="text-center">{{ $t("Оплата") }}</th>
							<th class="text-center">{{ $t("actions.title") }}</th>
						</tr>
					</thead>
					<tbody v-if="getSales && getSales.items && getSales.items.length > 0">
						<tr v-for="(item, index) in getSales.items" :key="`items12-${index}`">
							<td class="text-center">{{ index+1 }}</td>
							<td class="text-center">{{ item.saleNumber }}</td>
							<td class="text-center">{{ item.updateDate }}</td>
							<td class="text-center">{{ item.shopName }}</td>
							<td class="text-center">{{ item.cashboxName }}</td>
							<td class="text-center">
								<strong v-if="item.action == 'QAYTARISH'">{{ $t('pos.return') }}</strong>
								<strong v-else>{{ $t('sidebar.sales.ready') }}</strong>
							</td>
							<td class="text-center">
								<strong>{{ saleItemsCount(item) }}</strong>
							</td>
							<td class="text-center">
								{{ item.amountOfPaymentUzs | currency({symbol: returnCurrencyNameForDep(item.shopId), fractionCount: 2, symbolPosition: 'back'}) }}
							</td>
							<td class="text-center">
								{{ item.amountOfAfterPromoUzs | currency({symbol: returnCurrencyNameForDep(item.shopId), fractionCount: 2, symbolPosition: 'back'}) }}
							</td>
							<td class="text-center">
								<div v-if="item.paymentMap">
									<div v-for="(i, index) in item.paymentMap.CASH" :key="`cash-${index}`" class="d-flex align-items-center justify-content-center mb-1">
										<strong>Наличными: {{i.value}} {{i.currencyCode}}</strong>
										<b-link v-if="onlyAdmin" @click.prevent="openChangePaymentTypeModal(item, i)" class="ml-2 text-primary" title="Изменить тип оплаты">
											<i class="fa fa-pencil"></i>
										</b-link>
									</div>
									<div v-for="(i, index) in item.paymentMap.BANK_CARD" :key="`card-${index}`" class="d-flex align-items-center justify-content-center mb-1">
										<strong style="color: #4DBD74">{{i.paymentTypeCode}}</strong> &nbsp; {{i.value}} {{i.currencyCode}}
										<b-link v-if="onlyAdmin" @click.prevent="openChangePaymentTypeModal(item, i)" class="ml-2 text-primary" title="Изменить тип оплаты">
											<i class="fa fa-pencil"></i>
										</b-link>
									</div>
								</div>
							</td>
							<td class="text-center">
								<b-link @click.prevent="editBtn(item, 'forModal')">
									<i class="fa fa-eye editBtn" ></i>
								</b-link>
								<b-link @click.prevent="printCheck(item)" class="ml-3">
									<i class="fa fa-print editBtn"></i>
								</b-link>
							</td>
						</tr>
					</tbody>
					<tbody v-else>
						<tr>
							<td colspan="11" class="text-center"><b>{{ $t('empty') }}</b></td>
						</tr>
					</tbody>
				</table>
				<table v-if="isSalesByItem" class="table table-bordered table-striped table-hover">
					<thead>
						<tr>
							<th class="text-center">№</th>
							<th class="text-center" style="cursor: pointer" @click="search('number')">{{ $t('sale.saleNumber') }} <i :class="sortBy.saleNumber===''?`fa fa-arrows-v`:sortBy.saleNumber==='asc'?'fa fa-arrow-up':sortBy.saleNumber==='desc'?'fa fa-arrow-down':'fa fa-arrows-v'" class="ml-2"/></th>
							<th class="text-center" style="cursor: pointer" @click="search('date')">{{ $t('sale.saleDate') }} <i :class="sortBy.saleDate===''?`fa fa-arrows-v`:sortBy.saleDate==='asc'?'fa fa-arrow-up':sortBy.saleDate==='desc'?'fa fa-arrow-down':'fa fa-arrows-v'" class="ml-2"/></th>
							<th class="text-center">{{ $t('sale.shopName') }}</th>
							<th class="text-center">{{ $t('POS №') }}</th>
							<th class="text-center">{{ $t('sale.status') }}</th>
							<th class="text-center">{{ $t('sale.kol-vo') }}</th>
							<th class="text-center">{{ $t('pos.sum') }}</th>
							<th class="text-center">{{ $t('sale.sum-skidka') }}</th>
							<th class="text-center" style="cursor: pointer" @click="search('name')">{{ $t('pos.product') }} <i :class="sortBy.name===''?`fa fa-arrows-v`:sortBy.name==='asc'?'fa fa-arrow-up':sortBy.name==='desc'?'fa fa-arrow-down':'fa fa-arrows-v'" class="ml-2"/></th>
							<th class="text-center" style="cursor: pointer" @click="search('barcode')">{{ $t('goods.special-barcode') }} <i :class="sortBy.barcode===''?`fa fa-arrows-v`:sortBy.barcode==='asc'?'fa fa-arrow-up':sortBy.barcode==='desc'?'fa fa-arrow-down':'fa fa-arrows-v'" class="ml-2"/></th>
							<th class="text-center">{{ $t('goods.barcode') }}</th>
							<th class="text-center">{{ $t('goods.artikul') }}</th>
						</tr>
					</thead>
					<tbody v-if="salesByItemList.length > 0">
						<tr v-for="(item, index) in salesByItemList" :key="`items-${index}`">
							<td class="text-center">{{ index+1 }}</td>
							<td class="text-center">{{ item.saleNumber }}</td>
							<td class="text-center">{{ item.updateDate }}</td>
							<td class="text-center">{{ item.shopName }}</td>
							<td class="text-center">{{ item.cashboxName }}</td>
							<td class="text-center">
								<strong v-if="item.action == 'QAYTARISH'">{{ $t('pos.return') }}</strong>
								<strong v-else>{{ $t('sidebar.sales.ready') }}</strong>
							</td>
							<td class="text-center">{{ item.count }}</td>
							<td class="text-center">{{ item.priceUzs }}</td>
							<td class="text-center">{{ item.priceAfterUzs }}</td>
							<td>{{ item.itemName }}</td>
							<td class="text-center">{{ item.barcode }}</td>
							<td class="text-center">{{ item.multiBarcode }}</td>
							<td class="text-center">{{ item.artikul }}</td>
						</tr>
					</tbody>
					<tbody v-else>
						<tr>
							<td colspan="13" class="text-center"><b>{{ $t('empty') }}</b></td>
						</tr>
					</tbody>
				</table>
				<table v-if="isZReports" class="table table-bordered table-striped table-hover">
					<thead>
					<tr>
						<th class="text-center">№</th>
						<th class="text-center" style="cursor: pointer" @click="search('start')">Дата начала <i :class="sortBy.start===''?`fa fa-arrows-v`:sortBy.start==='asc'?'fa fa-arrow-up':sortBy.start==='desc'?'fa fa-arrow-down':'fa fa-arrows-v'" class="ml-2"/></th>
						<th class="text-center" style="cursor: pointer" @click="search('end')">Дата окончания <i :class="sortBy.end===''?`fa fa-arrows-v`:sortBy.end==='asc'?'fa fa-arrow-up':sortBy.end==='desc'?'fa fa-arrow-down':'fa fa-arrows-v'" class="ml-2"/></th>
						<th class="text-center" style="cursor: pointer" @click="search('dep')">{{ $t('sale.shopName') }} <i :class="sortBy.dep===''?`fa fa-arrows-v`:sortBy.dep==='asc'?'fa fa-arrow-up':sortBy.dep==='desc'?'fa fa-arrow-down':'fa fa-arrows-v'" class="ml-2"/></th>
						<th class="text-center">{{ $t('sale.status') }}</th>
						<th class="text-center">{{ $t("actions.title") }}</th>
					</tr>
					</thead>
					<tbody v-if="zReports && zReports.length > 0">
						<tr v-for="(item, index) in zReports" :key="`items2-${index}`">
							<td class="text-center">{{ index+1 }}</td>
							<td class="text-center">{{ item.startDate }}</td>
							<td class="text-center">{{ item.endDate }}</td>
							<td class="text-center">{{ item.companyDepartmentName }}</td>
							<td class="text-center">
								<b-badge variant="success" v-if="item.open" style="padding: 5px 10px;">Открыть</b-badge>
								<b-badge variant="info" v-else style="padding: 5px 10px;">Закрыто</b-badge>
							</td>
							<td class="text-center">
								<b-link @click.prevent="editBtn(item, 'forModal')">
									<i class="fa fa-eye editBtn" ></i>
								</b-link>
							</td>
						</tr>
					</tbody>
					<tbody v-else>
						<tr>
							<td colspan="6" class="text-center"><b>{{ $t('empty') }}</b></td>
						</tr>
					</tbody>
				</table>
				<table id="gridContainer" v-if="isZReports1" class="table table-hover table-striped table-bordered">
					<thead>
					<tr>
						<th rowspan="3" class="text-center">Дата</th>
						<th rowspan="3" class="text-center">Валюта</th>
						<th rowspan="3" class="text-center">Курсы</th>
						<th rowspan="3" class="text-center">Коэфф.пересчёта</th>
					</tr>
					<tr>
						<th colspan="7" class="text-center">Продажи</th>
					</tr>
					<tr>
						<th class="text-center">касса <br> по видам валют</th>
						<th class="text-center">Visa</th>
						<th class="text-center">UzCard</th>
						<th class="text-center">HUMO</th>
						<th class="text-center">UZUM</th>
						<th class="text-center">CLICK</th>
						<th class="text-center">Всего</th>
					</tr>
					</thead>
					<tbody v-for="(item, index) in zReportsList" :key="`items-2${index}`">
					<tr>
						<td :rowspan="item.CASH.length+3" class="text-center" style="padding-top: 2%">{{ item.zetDate }}</td>
					</tr>
					<tr v-for="(t,i) in item.CASH">
						<td class="text-center">{{ t.currency }}</td>
						<td class="text-center">{{ t.rate | currency({symbol: ' ', fractionCount: 2, symbolPosition: 'back'}) }}</td>
						<td class="text-center">{{ t.depRate | currency({symbol: ' ', fractionCount: 2, symbolPosition: 'back'}) }}</td>
						<td class="text-center">{{ t.amount | currency({symbol: ' ', fractionCount: 2, symbolPosition: 'back'}) }}</td>
						<td class="text-center" v-if="t.currency == item.VISA.currency">{{ item.VISA.amount | currency({symbol: ' ', fractionCount: 2, symbolPosition: 'back'}) }}</td>
						<td v-else/>
						<td class="text-center" v-if="t.currency == item.UZCARD.currency">{{ item.UZCARD.amount | currency({symbol: ' ', fractionCount: 2, symbolPosition: 'back'}) }}</td>
						<td v-else/>
						<td class="text-center" v-if="t.currency == item.HUMO.currency">{{ item.HUMO.amount | currency({symbol: ' ', fractionCount: 2, symbolPosition: 'back'}) }}</td>
						<td v-else/>
						<td class="text-center" v-if="t.currency == item.UZUM.currency">{{ item.UZUM.amount | currency({symbol: ' ', fractionCount: 2, symbolPosition: 'back'}) }}</td>
						<td v-else/>
						<td class="text-center" v-if="t.currency == item.CLICK.currency">{{ item.CLICK.amount | currency({symbol: ' ', fractionCount: 2, symbolPosition: 'back'}) }}</td>
						<td v-else/>
						<td class="text-center">{{  }}</td>
					</tr>
					<tr>
						<td colspan="3" class="text-center"><b>в долларах</b></td>
						<td class="text-center">{{ item.CASHEUR | currency({symbol: ' ', fractionCount: 2, symbolPosition: 'back'}) }}</td>
						<td class="text-center">{{ item.VISA.amountDep | currency({symbol: ' ', fractionCount: 2, symbolPosition: 'back'}) }}</td>
						<td class="text-center">{{ item.UZCARD.amountDep | currency({symbol: ' ', fractionCount: 2, symbolPosition: 'back'}) }}</td>
						<td class="text-center">{{ item.HUMO.amountDep | currency({symbol: ' ', fractionCount: 2, symbolPosition: 'back'}) }}</td>
						<td class="text-center">{{ item.UZUM.amountDep | currency({symbol: ' ', fractionCount: 2, symbolPosition: 'back'}) }}</td>
						<td class="text-center">{{ item.CLICK.amountDep | currency({symbol: ' ', fractionCount: 2, symbolPosition: 'back'}) }}</td>
						<td class="text-center">{{ item.TOTALEUR | currency({symbol: ' ', fractionCount: 2, symbolPosition: 'back'}) }}</td>
					</tr>
					<tr>
						<td colspan="3" class="text-center"><b>в сумах</b></td>
						<td class="text-center">{{ item.CASHUZS | currency({symbol: ' ', fractionCount: 2, symbolPosition: 'back'}) }}</td>
						<td class="text-center">{{ item.VISA.amountUzs | currency({symbol: ' ', fractionCount: 2, symbolPosition: 'back'}) }}</td>
						<td class="text-center">{{ item.UZCARD.amountUzs | currency({symbol: ' ', fractionCount: 2, symbolPosition: 'back'}) }}</td>
						<td class="text-center">{{ item.HUMO.amountUzs | currency({symbol: ' ', fractionCount: 2, symbolPosition: 'back'}) }}</td>
						<td class="text-center">{{ item.UZUM.amountUzs | currency({symbol: ' ', fractionCount: 2, symbolPosition: 'back'}) }}</td>
						<td class="text-center">{{ item.CLICK.amountUzs | currency({symbol: ' ', fractionCount: 2, symbolPosition: 'back'}) }}</td>
						<td class="text-center">{{ item.TOTALUZS | currency({symbol: ' ', fractionCount: 2, symbolPosition: 'back'}) }}</td>
					</tr>
					</tbody>
					<tfoot v-if="zReportsList.length > 0">
					<tr>
						<th colspan="9" class="text-right">Итого </th>
						<th class="text-center">в долларах:</th>
						<th class="text-center">{{ finalTotalEur | currency({symbol: ' ', fractionCount: 2, symbolPosition: 'back'}) }}</th>
					</tr>
					<tr>
						<th colspan="9" class="text-right">Итого </th>
						<th class="text-center">в сумах:</th>
						<th class="text-center">{{ finalTotalUzs | currency({symbol: ' ', fractionCount: 2, symbolPosition: 'back'}) }}</th>
					</tr>
					</tfoot>
				</table>
				<b-button  class="float-right mt-1 exs hidden-print" v-if="isZReports1 && zReportsList.length > 0" @click="excelExport1('gridContainer', ' Z отчеты*')" variant="primary">{{ $t('excel-export.download-excel') }}</b-button>
				<table v-if="isErrorSales" class="table table-hover table-striped table-bordered">
					<thead>
						<tr>
							<th class="text-center">№</th>
							<th class="text-center">Номер чека</th>
							<th class="text-center">Дата продажи</th>
							<th class="text-center">Отдел</th>
							<th class="text-center">POS №</th>
							<th class="text-center">Кол-во товаров</th>
							<th class="text-center">Сумма</th>
							<th class="text-center">Сумма со скидкой</th>
							<th class="text-center">Оплата</th>
							<th class="text-center">Действие</th>
						</tr>
					</thead>
					<tbody v-if="kkmSaleList && kkmSaleList.length > 0">
						<tr v-for="(item, index) in kkmSaleList" :key="`kkm-sale-${index}`">
							<td class="text-center">{{ paginate(index, errorSalePayload.page, errorSalePayload.limit) }}</td>
							<td class="text-center">{{ item.saleNumber }}</td>
							<td class="text-center">{{ item.saleDate }}</td>
							<td class="text-center">{{ item.shopName }}</td>
							<td class="text-center">{{ item.cashboxName }}</td>
							<td class="text-center">{{ item.saleItems.length + item.productItems.length }}</td>
							<td class="text-center">{{ item.amountOfPaymentUzs | currency({symbol: '', fractionCount: 2, symbolPosition: 'back'}) }}</td>
							<td class="text-center">{{ item.amountOfAfterPromoUzs | currency({symbol: '', fractionCount: 2, symbolPosition: 'back'}) }}</td>
							<td class="text-center">
								<strong v-for="(i, ind) in item.paymentMap.CASH">{{i.value}} {{i.currencyCode}}<br></strong>
								<strong v-for="(it, inde) in item.paymentMap.BANK_CARD"><p style="color: #4DBD74">{{it.paymentTypeCode}}</p> {{it.value}} {{it.currencyCode}}<br></strong>
							</td>
							<td class="text-center">
								<b-button @click="viewBtn(item)" variant="dark" class="mr-2"><i class="fa fa-eye"/></b-button>
								<b-button @click="viewBtn(item, true)" variant="primary"><i class="fa fa-edit"/></b-button>
							</td>
						</tr>
					</tbody>
					<tbody v-else>
						<tr>
							<td colspan="10" class="text-center">Пока нет информации</td>
						</tr>
					</tbody>
				</table>
				<table v-if="isKorzinka" class="table table-hover table-striped table-bordered">
					<thead>
					<tr>
						<th class="text-center">№</th>
						<th class="text-center">Номер чека</th>
						<th class="text-center">Дата продажи</th>
						<th class="text-center">Отдел</th>
						<th class="text-center">POS №</th>
						<th class="text-center">Сумма</th>
						<th class="text-center">Сумма со скидкой</th>
						<th class="text-center">Оплата</th>
						<th class="text-center">Действие</th>
					</tr>
					</thead>
					<tbody v-if="korzinkaList && korzinkaList.length > 0">
					<tr v-for="(item, index) in korzinkaList" :key="`korzinka-sale-${index}`">
						<td class="text-center">{{ index + 1 }}</td>
						<td class="text-center">{{ item.saleNumber }}</td>
						<td class="text-center">{{ item.saleDate }}</td>
						<td class="text-center">{{ item.shopName }}</td>
						<td class="text-center">{{ item.cashboxName }}</td>
						<td class="text-center">
							{{
								item.amountOfPaymentUzs | currency({
									symbol: '',
									fractionCount: 2,
									symbolPosition: 'back'
								})
							}}
						</td>
						<td class="text-center">
							{{
								item.amountOfAfterPromoUzs | currency({
									symbol: '',
									fractionCount: 2,
									symbolPosition: 'back'
								})
							}}
						</td>
						<td class="text-center">
							<div v-if="item.paymentMap">
								<strong v-for="(i, ind) in item.paymentMap.CASH" :key="`k-cash-${ind}`">
									{{ i.value }} {{ i.currencyCode }}<br>
								</strong>
								<strong v-for="(it, inde) in item.paymentMap.BANK_CARD" :key="`k-card-${inde}`">
									<p style="color: #4DBD74; margin-bottom: 0">{{ it.paymentTypeCode }}</p> {{ it.value }} {{ it.currencyCode }}<br>
								</strong>
							</div>
						</td>
						<td class="text-center">
							<b-button @click="markKkmSuccess(item.id)" variant="success" size="sm" title="Подтвердить">
								<i class="fa fa-check"/>
							</b-button>
						</td>
					</tr>
					</tbody>
					<tbody v-else>
					<tr>
						<td colspan="9" class="text-center">
							<b-spinner v-if="korzinkaLoading" small variant="primary"></b-spinner>
							<span v-else>Пока нет информации</span>
						</td>
					</tr>
					</tbody>
				</table>
				<div v-if="getTableItems && isSales">
					<download-excel size="sm" class="btn btn-success" :data="itemsForExcel" worksheet="My Worksheet" name="Excel"/><br/><br/>
				</div>
				<div v-if="salesByItemList.length > 0 && isSalesByItem">
					<download-excel size="sm" class="btn btn-success" :data="saleByItemsForExcel" worksheet="Продажи по товарам" name="Excel*"/><br/><br/>
				</div>
				<nav class="text-center mt-2">
					<div v-if="selected=='sales'">
						<b-pagination
							size="sm"
							:total-rows="getSales.total"
							:per-page="perPage"
							v-model="currentPage"
							:prev-text="$t('pagination.prev')"
							:next-text="$t('pagination.next')"
							hide-goto-end-buttons
						/>
					</div>
					<div v-else-if="selected=='salesByItem'">
						<b-pagination
							size="sm"
							:total-rows="salesByItemTotal"
							:per-page="salesByItemLimit"
							v-model="salesByItemPage"
							:prev-text="$t('pagination.prev')"
							:next-text="$t('pagination.next')"
							hide-goto-end-buttons
						/>
					</div>
					<div v-else-if="selected=='zReports'">
						<b-pagination
							size="sm"
							:total-rows="zReportsTotal"
							:per-page="perPage"
							v-model="currentPage"
							:prev-text="$t('pagination.prev')"
							:next-text="$t('pagination.next')"
							hide-goto-end-buttons
						/>
					</div>
					<div v-else-if="isErrorSales">
						<b-pagination-new
							background
							:total="kkmTotal"
							layout="prev, pager, next"
							:page-size="errorSalePayload.limit"
							:current-page.sync="errorSalePayload.page"
						/>
					</div>
				</nav>
				<div v-if="loader" class="spinner-wrapper">
					<b-spinner variant="primary"></b-spinner>
				</div>
			</div>
			<!--			View ErrorSaleItems			-->
			<b-modal v-model="viewItems" size="xl" hide-footer>
				<table class="b-table table-hover table-striped table-bordered" style="width: 100%">
					<thead>
						<tr>
							<th class="text-center">№</th>
							<th class="text-center">Продукты</th>
							<th class="text-center">Спец-код</th>
							<th class="text-center">Срок годности</th>
							<th class="text-center">Кол-во</th>
							<th class="text-center">Цена</th>
							<th class="text-center">ИКПУ</th>
						</tr>
					</thead>
					<tbody v-if="kkmData">
						<tr v-for="(item, index) in kkmData.saleItems" v-if="kkmData.saleItems && kkmData.saleItems.length > 0" :key="`kkm-sale-${index}`">
							<td class="text-center">{{ index+1 }}</td>
							<td class="text-center">{{ item.name }}</td>
							<td class="text-center">{{ item.barcode }}</td>
							<td class="text-center">{{ item.termOfItem }}</td>
							<td class="text-center">{{ item.count + ' ' + item.unitName }}</td>
							<td class="text-center">{{ item.priceUzs }}</td>
							<td class="text-center">
								<b-form-input v-model="item.mxikCode" v-if="kkmData&&kkmData.edit" placeholder="ИКПУ" type="number"/>
								<span v-else>{{ item.mxikCode }}</span>
							</td>
						</tr>
						<tr v-for="(item, index) in kkmData.productItems" v-if="kkmData.productItems && kkmData.productItems.length > 0" :key="`kkm-sale1-${index}`">
							<td class="text-center">{{ kkmData.saleItems.length+index+1 }}</td>
							<td class="text-center">{{ item.name }}</td>
							<td class="text-center">{{ item.barcode }}</td>
							<td class="text-center">{{ item.termOfItem }}</td>
							<td class="text-center">{{ item.count + ' ' + (item.unitName ? item.unitName : ' dona') }}</td>
							<td class="text-center">{{ item.priceUzs }}</td>
							<td class="text-center">
								<b-form-input v-model="item.mxikCode" v-if="kkmData&&kkmData.edit" placeholder="ИКПУ" type="number"/>
								<span v-else>{{ item.mxikCode }}</span>
							</td>
						</tr>
					</tbody>
					<tbody v-else>
						<tr>
							<td colspan="6" class="text-center">Пока нет информации</td>
						</tr>
					</tbody>
				</table>
				<hr>
				<b-row v-if="kkmData&&kkmData.edit" class="mt-3">
					<b-col align="left">
						<b-button @click="kkmData=null;viewItems=false" variant="danger">{{ $t('cancel') }}</b-button>
					</b-col>
					<b-col align="right">
						<b-button @click="saveKkmData" variant="success">{{ $t('warehouse.document.saveAndFinish') }}</b-button>
					</b-col>
				</b-row>
			</b-modal>
		</b-card>
		<!-- CHECK TO PRINT -->
		<pos-check></pos-check>
		<b-modal
			id="saleViewModal"
			ref="saleAndZReportModal"
			size="xl"
			hide-footer
			hide-header
			:no-close-on-esc="true"
			:no-close-on-backdrop="true"
			class="hidden-print body-padding-0"
		>
			<sale-view
				v-if="isSales"
				:item="item"
				@close="closeSaleAndZReportModal"
				:currencyForSaleView="currencyForSaleView"
			></sale-view>
			<x-and-z-report
				v-else-if="zReportShow"
				is-z-report
				is-from-z-reports-page
				:z-report-id="currentItemId"
				:dep-id="currentItemDepId"
				@close="closeSaleAndZReportModal"
			></x-and-z-report>
		</b-modal>
		<vs-sidebar
			position-right
			parent="body"
			default-index="1"
			color="primary"
			class="create-modal priceSidebar hidden-print"
			spacer
			v-model="activeSidebar"
			:click-not-close="true"
		>
			<RefundEdit :item="item" @closeSidebar="closeSidebar" @updateSaleRefound="updateSaleRefound"></RefundEdit>
		</vs-sidebar>
		<b-modal
			id="changePaymentTypeModal"
			ref="changePaymentTypeModal"
			title="Изменение типа оплаты"
			size="lg"
			hide-footer
			class="hidden-print"
		>
			<div v-if="selectedSaleForPayment">
				<b-row class="mb-3">
					<b-col md="6">
						<strong>{{ $t('sale.saleNumber') }}:</strong> {{ selectedSaleForPayment.saleNumber }}
					</b-col>
					<b-col md="6">
						<strong>{{ $t('sale.saleDate') }}:</strong> {{ selectedSaleForPayment.updateDate }}
					</b-col>
				</b-row>
				<b-row class="mb-3">
					<b-col md="6">
						<strong>{{ $t('sale.shopName') }}:</strong> {{ selectedSaleForPayment.shopName }}
					</b-col>
					<b-col md="6">
						<strong>POS №:</strong> {{ selectedSaleForPayment.cashboxName }}
					</b-col>
				</b-row>
				<b-row class="mb-3" v-if="selectedPaymentItemForChange">
					<b-col md="6">
						<strong>Сумма оплаты:</strong> {{ selectedPaymentItemForChange.value }} {{ selectedPaymentItemForChange.currencyCode }}
					</b-col>
					<b-col md="6">
						<strong>Текущий тип оплаты:</strong>
						<span style="color: #4DBD74; font-weight: bold;">{{ selectedPaymentItemForChange.paymentTypeCode }}</span>
					</b-col>
				</b-row>
				<b-row class="mb-3" v-else>
					<b-col md="6">
						<strong>{{ $t('pos.sum') }}:</strong>
						{{
							selectedSaleForPayment.amountOfPaymentUzs | currency({
								symbol: returnCurrencyNameForDep(selectedSaleForPayment.shopId),
								fractionCount: 2,
								symbolPosition: 'back'
							})
						}}
					</b-col>
					<b-col md="6">
						<strong>Текущая оплата:</strong>
						<span v-if="selectedSaleForPayment.paymentMap">
							<span v-for="(i, idx) in selectedSaleForPayment.paymentMap.CASH" :key="`c-${idx}`">
								Наличными: {{ i.value }} {{ i.currencyCode }} &nbsp;
							</span>
							<span v-for="(i, idx) in selectedSaleForPayment.paymentMap.BANK_CARD" :key="`b-${idx}`">
								{{ i.paymentTypeCode }}: {{ i.value }} {{ i.currencyCode }} &nbsp;
							</span>
						</span>
					</b-col>
				</b-row>

				<hr>

				<b-row class="mt-3">
					<b-col md="12">
						<label><strong>Новый тип оплаты:</strong></label>
						<multiselect
							v-model="newPaymentTypeSelected"
							:options="paymentTypeList"
							track-by="id"
							label="name"
							:show-labels="false"
							:allow-empty="false"
							placeholder="Выберите тип оплаты"
						>
						</multiselect>
					</b-col>
				</b-row>

				<b-row class="mt-4">
					<b-col align="left">
						<b-button variant="secondary" @click="closeChangePaymentTypeModal">
							{{ $t('cancel') }}
						</b-button>
					</b-col>
					<b-col align="right">
						<b-button variant="success" :disabled="!newPaymentTypeSelected || savingPaymentType" @click="saveNewPaymentType">
							<b-spinner small v-if="savingPaymentType"></b-spinner>
							<span v-else>{{ $t('warehouse.document.saveAndFinish') }}</span>
						</b-button>
					</b-col>
				</b-row>
			</div>
		</b-modal>
	</div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import PosCheck from '../pos/components/PosCheck';
import ApiService from "../../../services/api.service";

import VisibleColumns from "../../warehouse-management/warehouse/blocks/VisibleColumns";
import MaskedInput from "vue-masked-input";
import Multiselect from "vue-multiselect";
import RefundEdit from "./SaleEdit";
import SaleView from "./SaleView";
import {DxColumn, DxDataGrid, DxPager, DxPaging} from "devextreme-vue/data-grid";
import RefundService from "../../../services/refund.service";
import XAndZReport from "@/views/point-of-sale/pos/components/Xreport/XAndZReport";
import {validators} from "../../warehouse-management/wh-documents/mixins/validators";
import WhDocument from "../../../services/wh-document.service";
import PosService from "../../../services/pos.service";
import {Pagination} from 'element-ui'

export default {
	mixins: [validators],
	components: {
		VisibleColumns,
		XAndZReport,
		DxDataGrid,
		DxColumn,
		DxPaging,
		DxPager,
		MaskedInput,
		Multiselect,
		RefundEdit,
		SaleView,
		PosCheck,
		"b-pagination-new":Pagination
	},
	data() {
		return {
			loading: false,
			validators: {},
			selectedDepForSearch: null,
			cashboxId: null,
			cashboxSaleId: null,
			cashboxList: [],
			cashboxSaleList: [],
			salesByItemList: [],
			currency: [
				'дол',
				'евро',
				'фунты',
				'сумы',
				'рос'
			],
			zReportsList: [],
			salesByItemTotal: 0,
			salesByItemLimit: 20,
			salesByItemLimit1: 20,
			salesByItemPage: 1,
			zReportShow: false,
			currentItemId: null,
			currentItemDepId: null,
			dataSource: null,
			json_fields: {
				ID: "id",
				"Номер чека": "checkNumber",
				"Дата продажи": "saleData",
				Отдел: "department",
				Статус: "status",
				"Кол-во товаров": "qtyItems",
				Сумма: "skidka",
				"Сумма со скидкой": "date",
				Клиент: "client"
			},
			itemName: '',
			barcode: '',
			multiBarcode: '',
			artikul: '',
			loader: true,
			items: [],
			activeEditSidebar: false,
			currentPage: 1,
			zReportGetById: {},
			perPage: 20,
			perPage1: 20,
			fromDate: "",
			toDate: "",
			check: null,
			isDropped: false,
			popoverShow: false,
			selectedDepartment: [],
			zReportDep: null,
			saleNumber: "",
			activeSidebar: false,
			item: [],
			currencyForSaleView: "",
			currencyForZReportView: "",
			currentZReport: {},
			contrAgent: [],
			checkStatus: null,
			selected: "sales",
			options: [
				{
					text: this.$t("sidebar.sales.title"),
					value: "sales",
					can: true
				},
				{
					text: 'Продажи по товарам',
					value: "salesByItem",
					can: true
				},
				{
					text: this.$t("zOtchet.list"),
					value: "zReports",
					can: true
				},
				{
					text: this.$t("zOtchet.list") + '*',
					value: "zReports*",
					can: true
				},
				{
					text: 'Напечатанные продажи',
					value: 'errorSales',
					can: true
				},
				{
					text: 'Корзина',
					value: 'korzinka',
					can: localStorage.getItem('userName')==='admin'
				}
			],
			errorSaleId: null,
			errorSaleList: [],
			korzinkaList: [],
			korzinkaLoading: false,
			errorSalePayload: {
				page: 1,
				limit: 20
			},
			kkmSaleList: [],
			kkmTotal: 0,
			viewItems: false,
			kkmData: {},
			paymentTypeList: [],
			selectedSaleForPayment: null,
			selectedPaymentItemForChange: null,
			newPaymentTypeSelected: null,
			savingPaymentType: false,
			sortBy: {
				saleNumber: '',
				saleDate: '',
				name: '',
				barcode: '',
				start: '',
				end: '',
				dep: ''
			}
		};
	},
	watch: {
		salesByItemLimit1: {
			handler(t) {
				if (t == 'all') {
					this.salesByItemLimit = this.salesByItemTotal
				} else {
					this.salesByItemLimit = t
				}
				this.search();
			}
		},
		perPage1: {
			handler(t) {
				if (t == 'all') {
					this.perPage = this.getSales.total
				} else {
					this.perPage = t
				}
				this.search();
			}
		},
		salesByItemPage: {
			handler(t) {
				this.search();
			}
		},
		currentPage: {
			async handler() {
				if (this.selected == "sales" || this.selected=='salesByItem') {
					await this.search();
				}
				if (this.selected == "zReports") {
					await this.search();
				}
			}
		},
		'selectedDepartment': {
			handler(e) {
				if (e) {
					this.cashboxSaleList = []
					e.forEach(dep => {
						ApiService.get(`cashbox/get/by-dep-id/${dep.id}`).then(res => {
							res.data.forEach(tmp => {
								this.cashboxSaleList.push(tmp)
							})
						})
					})
				}
			}
		},
		'selected': {
			handler(s) {
				if (this.isErrorSales) {
					this.getErrorSales();
				} else if (this.isKorzinka) {
					this.fetchKorzinkaList();
				}
			}
		},
		'errorSaleId': {
			handler(e) {
				this.getErrorSaleList(e.departmentId, e.cashboxId);
			}
		},
		'errorSalePayload.page': {
			handler(p) {
				this.getErrorSaleList(this.errorSaleId.departmentId, this.errorSaleId.cashboxId);
			}
		}
	},
	methods: {
		excelExport1(tableID, filename = '') {
			var uri = 'data:application/vnd.ms-excel;base64,',
				template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
				base64 = function(s) {
					return window.btoa(unescape(encodeURIComponent(s)))
				},
				format = function(s, c) {
					return s.replace(/{(\w+)}/g, function(m, p) {
						return c[p];
					})
				}
			var toExcel = document.getElementById(tableID).innerHTML;
			var ctx = {
				worksheet: name || '',
				table: toExcel
			};
			var link = document.createElement("a");
			link.download = `${filename}.xls`;
			link.href = uri + base64(format(template, ctx))
			link.click();
		},
		...mapActions('departments', ['fetchMyDepartments']),
		fetchCashboxList() {
			if (this.zReportDep) {
				ApiService.get(`cashbox/get/by-dep-id/${this.zReportDep.id}`)
					.then(res => {
						this.cashboxList = res.data
						for (let i = 0; i < res.data.length; i++)
							this.check = res.data[i].id
					})
			}
		},
		errorSaleLabel(label) {
			return `Отдел: ${label.departmentName}, POS №: ${label.cashboxName}, Кол-во: ${label.checkCount}`
		},
		async fetchKorzinkaList() {
			this.korzinkaLoading = true;
			await ApiService.get('/sale/kkm-pending-list').then(res => {
				this.korzinkaList = res.data || [];
			}).catch(err => {
				this.$vs.notify({
					title: err.message || 'Error',
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			}).finally(() => {
				this.korzinkaLoading = false;
			});
		},
		markKkmSuccess(saleId) {
			this.$bvModal.msgBoxConfirm('Вы уверены, что хотите подтвердить эту продажу?', {
				title: 'Подтверждение',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				okTitle: 'Да',
				cancelTitle: 'Отмена',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(async (value) => {
				if (value) {
					this.korzinkaLoading = true;
					await ApiService.put(`/sale/kkm-mark-success/${saleId}`).then(() => {
						this.$vs.notify({
							title: 'Успешно обновлено',
							color: 'success',
							icon: 'check',
							position: 'top-right'
						});
						this.fetchKorzinkaList();
					}).catch(err => {
						this.$vs.notify({
							title: err.message || 'Ошибка при обновлении',
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						});
					}).finally(() => {
						this.korzinkaLoading = false;
					});
				}
			});
		},
		getErrorSaleList(depId, cashId) {
			PosService.getKkmSaleList(depId, cashId, this.errorSalePayload).then(res => {
				this.kkmSaleList = res.data.items
				this.kkmTotal = res.data.total
			}).catch(er => {
				this.$vs.notify({
					title: er.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		getErrorSales() {
			WhDocument.getErrorSales().then(res => {
				this.errorSaleList = res.data
			}).catch(e => {
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		columnListener($event) {
			this.columns = $event
		},
		async removePageSizeStyle() {
			var el = document.getElementById('stylePrintSizeId');
			if (el) {
				el.remove(); // Removes the div with the 'stylePrintSizeId' id
			}
		},
		async setPageSizeStyle(sizeValue) {
			var css = `@page { size: ${sizeValue}; }`,
				head = document.head || document.getElementsByTagName('head')[0],
				style = document.createElement('style');

			style.type = 'text/css';
			style.media = 'print';
			style.id = 'stylePrintSizeId';

			if (style.styleSheet) {
				style.styleSheet.cssText = css;
			} else {
				style.appendChild(document.createTextNode(css));
			}

			head.appendChild(style);
		},
		async printCheck(data) {
			await this.$store.commit('pos/setCurrentSaleForCheck', data.item);
			await this.removePageSizeStyle();
			await this.setPageSizeStyle('portrait');
			window.print();
		},
		closeSaleAndZReportModal() {
			this.$refs.saleAndZReportModal.hide();
			this.zReportShow = false
		},
		hasSponsorshipPayment(payments) {
			let foundIndex = payments.findIndex(
				payment => payment.paymentTypeCode == "HOMIYLIK"
			);
			if (foundIndex > -1) {
				return true;
			}
			return false;
		},
		hasDeptPayment(payments) {
			let foundIndex = payments.findIndex(
				payment => payment.paymentTypeCode == "QARZGA"
			);
			if (foundIndex > -1) {
				return true;
			}
			return false;
		},
		getamountOfSumma(el) {
			return (
				el.amountOfPaymentUzs.toFixed(2) +
				" " +
				this.returnCurrencyNameForDep(
					el.payments.length > 0 ? el.payments[0].paymentTypeId : {}
				)
			);
		},
		getamountOfDiscountSumma(el) {
			return (
				el.amountOfAfterPromoUzs.toFixed(2) +
				" " +
				this.returnCurrencyNameForDep(
					el.payments.length > 0 ? el.payments[0].paymentTypeId : {}
				)
			);
		},
		getPaymentStatus(el) {
			for (let i = 0; i < el.payments.length; i++) {
				if (
					el.payments[i].paymentTypeCode == "QARZGA" &&
					el.payments.length >= 1
				) {
					return (
						this.$t("xAtchot.debt") +
						" " +
						el.payments[i].value +
						" " +
						this.returnCurrencyNameForDep(el.payments[i].paymentTypeId)
					);
				}
				if (
					el.payments[i].paymentTypeCode == "HOMIYLIK" &&
					el.payments.length >= 1
				) {
					return (
						this.$t("sidebar.sales.sponsor") +
						" " +
						el.payments[i].value +
						" " +
						this.returnCurrencyNameForDep(el.payments[i].paymentTypeId)
					);
				}
				if (
					el.payments.length <= 1 &&
					el.payments[i].paymentTypeCode != "QARZGA" &&
					el.payments[i].paymentTypeCode != "HOMIYLIK"
				) {
					return this.$t("sidebar.sales.ready");
				}
			}
		},
		returnCurrencyNameForDep(shopId) {
			if (this.getDepartments.length > 0) {
				let tempForDep = this.getDepartments.find(dep => {
					return dep.id == shopId;
				});
				if (tempForDep) {
					return tempForDep.currencyName;
				} else {
					return this.userDepCurrencyName;
				}
			} else {
				return this.userDepCurrencyName;
			}
		},
		...mapActions("refunds", [
			"getSaleLists",
			"getZreportsList",
			"getItemsFromId",
			"setRefound",
			"fetchRetailReturnSales"
		]),
		...mapActions("zetReport", ["getZReportById"]),
		...mapActions("prices", ["getDepartmentList"]),
		...mapActions("contragents", ["fetchContragents"]),
		async search(sort) {
			if (sort) {
				if (sort === 'number') {
					this.sortBy.saleNumber = this.sortBy.saleNumber === '' ? 'asc' : this.sortBy.saleNumber === 'asc' ? 'desc' : this.sortBy.saleNumber === 'desc' ? '' : ''
				} else if (sort === 'date') {
					this.sortBy.saleDate = this.sortBy.saleDate === '' ? 'asc' : this.sortBy.saleDate === 'asc' ? 'desc' : this.sortBy.saleDate === 'desc' ? '' : ''
				} else if (sort === 'name') {
					this.sortBy.name = this.sortBy.name === '' ? 'asc' : this.sortBy.name === 'asc' ? 'desc' : this.sortBy.name === 'desc' ? '' : ''
				} else if (sort === 'barcode') {
					this.sortBy.barcode = this.sortBy.barcode === '' ? 'asc' : this.sortBy.barcode === 'asc' ? 'desc' : this.sortBy.barcode === 'desc' ? '' : ''
				} else if (sort === 'start') {
					this.sortBy.start = this.sortBy.start === '' ? 'asc' : this.sortBy.start === 'asc' ? 'desc' : this.sortBy.start === 'desc' ? '' : ''
				} else if (sort === 'end') {
					this.sortBy.end = this.sortBy.end === '' ? 'asc' : this.sortBy.end === 'asc' ? 'desc' : this.sortBy.end === 'desc' ? '' : ''
				} else if (sort === 'dep') {
					this.sortBy.dep = this.sortBy.dep === '' ? 'asc' : this.sortBy.dep === 'asc' ? 'desc' : this.sortBy.dep === 'desc' ? '' : ''
				}
			} else {
				this.sortBy.saleNumber = ''
				this.sortBy.saleDate = ''
				this.sortBy.name = ''
				this.sortBy.barcode = ''
				this.sortBy.start = ''
				this.sortBy.end = ''
				this.sortBy.dep = ''
			}
			if (this.selected == "sales") {
				if (this.selectedDepartment.length > 0) {
					this.loader = true;
					this.loading = true;
					this.isDropped = true;
					const departments = this.selectedDepartment.map(department => {
						return department.id;
					});
					const contrAgentList = this.contrAgent.map(contragent => {
						return contragent.id;
					});
					let data = {
						page: this.currentPage,
						limit: this.perPage,
						startDate: this.fromDate,
						endDate: this.toDate,
						saleNumber: this.saleNumber,
						action: this.checkStatus,
						department: departments,
						cashboxId: this.cashboxSaleId ? this.cashboxSaleId.id : null,
						contragent: contrAgentList,
						sort: this.sortBy
					};
					// IF RETURN STATUS IS SELECTED
					// if (this.checkStatus == "QAYTARISH") {
					// 	await this.fetchRetailReturnSales(data);
					// } else {
						await this.getSaleLists(data);
					// }
					this.loader = false;
					this.loading = false;
				} else {
					this.$vs.notify({
						text: "Выберите Подразделение",
						color: "warning",
						icon: "close",
						position: "top-right"
					});
					return 0;
				}
			} else if (this.selected == "salesByItem") {
				if (this.selectedDepartment.length > 0) {
					this.loader = true;
					this.loading = true;
					this.isDropped = true;
					const departments = this.selectedDepartment.map(department => {
						return department.id;
					});
					const contrAgentList = this.contrAgent.map(contragent => {
						return contragent.id;
					});
					let data = {
						page: this.salesByItemPage,
						limit: this.salesByItemLimit,
						startDate: this.fromDate,
						endDate: this.toDate,
						saleNumber: this.saleNumber,
						action: this.checkStatus,
						department: departments,
						cashboxId: this.cashboxSaleId ? this.cashboxSaleId.id : null,
						contragent: contrAgentList,
						itemName: this.itemName,
						barcode: this.barcode,
						multiBarcode: this.multiBarcode,
						artikul: this.artikul,
						sort: this.sortBy
					};
					await RefundService.getSaleByItemList(data).then(res => {
						this.salesByItemList = res.data.items
						this.salesByItemTotal = res.data.total
					}).catch(e => {
						this.$vs.notify({
							title: e.response.message,
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						})
					})
					this.loader = false;
					this.loading = false;
				} else {
					this.$vs.notify({
						text: "Выберите Подразделение",
						color: "warning",
						icon: "close",
						position: "top-right"
					});
					return 0;
				}
			} else if (this.selected == 'zReports') {
				if (this.zReportDep && this.cashboxId) {
					this.loading = true
					if (this.fromDate == "") {
						this.fromDate = null;
					}
					if (this.toDate == "") {
						this.toDate = null;
					}

					await this.getZreportsList({
						departmentId: this.zReportDep.id,
						cashboxId: this.cashboxId.id,
						startDate: this.fromDate,
						endDate: this.toDate,
						page: this.currentPage,
						limit: 20,
						sort: this.sortBy
					});
					this.loading = false
				} else {
					this.$vs.notify({
						text: "Выберите Подразделение",
						color: "warning",
						icon: "close",
						position: "top-right"
					});
					return 0;
				}
			} else {
				if (this.zReportDep && this.cashboxId && this.fromDate && this.toDate) {
					let dep = []
					dep.push(this.zReportDep.id)
					let data = {
						department: dep,
						cashboxId: this.cashboxId.id,
						startDate: this.fromDate,
						endDate: this.toDate
					}
					await RefundService.getZReportList(data).then(res => {
						this.zReportsList = res.data
					}).catch(e => {
						this.$vs.notify({
							title: this.$t('words.error'),
							text: e,
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						})
					})
				} else {
					this.$vs.notify({
						text: "Выберите Подразделение",
						color: "warning",
						icon: "close",
						position: "top-right"
					});
					return 0;
				}
			}
		},
		saleItemsCount(item) {
			let count = 0;
			if (item.saleItems && item.saleItems.length > 0) {
				item.saleItems.forEach(sale => {
					count += sale.count;
				});
			}
			if (item.productItems && item.productItems.length > 0) {
				item.productItems.forEach(sale => {
					count += sale.count;
				});
			}
			return count;
		},
		showEditPopover() {
			this.popoverShow = true;
		},
		getDepartmentsLocal() {
			return this.getDepartments;
		},
		openSearchForm() {
			this.isDropped = !this.isDropped;
		},
		closeEditSidebar() {
			this.activeEditSidebar = false;
		},
		async viewBtn(item, tmp) {
			await ApiService.get(`/sale/responseEmptyKKMCountWithDepWithCashboxForMxik/${item.id}`).then(res => {
				let data = JSON.parse(res.data.kkmData)
				if (item.saleItems&&item.saleItems.length>0) {
					item.saleItems.forEach(tmp => {
						data.products.forEach(qwe => {
							if (tmp.multiBarcodeString==qwe.barcode)
								tmp.mxikCode = qwe.class_code
						})
					})
				}
				if (item.productItems&&item.productItems.length>0) {
					item.productItems.forEach(tmp => {
						data.products.forEach(qwe => {
							if (tmp.multiBarcodeString==qwe.barcode)
								tmp.mxikCode = qwe.class_code
						})
					})
				}
				this.kkmData = item
				this.kkmData.kkmData = data
				if (tmp)
					this.kkmData.edit = true
				this.viewItems = true
			}).catch(e => {
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		async saveKkmData() {
			if (this.kkmData.saleItems&&this.kkmData.saleItems.length>0) {
				this.kkmData.saleItems.forEach(tmp => {
					this.kkmData.kkmData.products.forEach(qwe => {
						if (tmp.multiBarcodeString==qwe.barcode)
							qwe.class_code = tmp.mxikCode
					})
				})
			}
			if (this.kkmData.productItems&&this.kkmData.productItems.length>0) {
				this.kkmData.productItems.forEach(tmp => {
					this.kkmData.kkmData.products.forEach(qwe => {
						if (tmp.multiBarcodeString==qwe.barcode)
							qwe.class_code = tmp.mxikCode
					})
				})
			}
			let data = JSON.stringify(this.kkmData.kkmData)
			await ApiService.post(`/sale/responseEmptyKKMCountWithDepWithCashboxForMxikUpdate/${this.kkmData.id}`, data).then(res => {
				this.viewItems = false
				this.kkmData = null
				this.$vs.notify({
					title: 'Success',
					color: 'success',
					icon: 'close',
					position: 'top-right'
				});
			}).catch(e => {
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		async editBtn(data, forText = "refund") {
			this.$refs.saleAndZReportModal.show()

			//this.$refs['popover-'+data.index].$emit('close')
			this.currencyForSaleView = this.returnCurrencyNameForDep(
				data.shopId
			);
			this.item = data;
			if (forText !== "forModal") {
				this.activeSidebar = true;
			}
			if (this.selected == "zReports") {
				this.zReportShow = true
				this.currencyForZReportView = this.returnCurrencyNameForDep(
					data.companyDepartmentId
				);
				// 24.01.2020 ZREPORT BY ID APISI O'ZGARTIRILDI
				// RefundService.getZReportById(data.item.id, data.item.companyDepartmentId).then(response => {
				// 	this.zReportGetById = response.data;
				// })

				// YANGISI
				let payload = {
					zReportId: data.id,
					depId: data.companyDepartmentId,
					cashboxId: data.cashboxId
				};
				this.currentItemId = data.id
				this.currentItemDepId = data.companyDepartmentId
				await this.getZReportById(payload);
			} else {
				if (this.checkStatus == "QAYTARISH") {
					await this.getSaleById(data.id);
					this.item = this.currentSaleWithId;
				}
			}
			this.popoverShow = false;
		},
		async updateSaleRefound(obj) {
			this.activeSidebar = false;
			await this.setRefound(obj);
			let data = {
				page: this.currentPage,
				limit: this.perPage
			};
			await this.getSaleLists(data);
		},
		paginate(index, page_size, page_number) {
			--page_size;
			return (page_number * page_size) + index + 1;
		},
		closeSidebar() {
			this.activeSidebar = false;
		},
		fetchPaymentTypeList() {
			return ApiService.get(`references/BANK_CARD/list`)
				.then(res => {
					this.paymentTypeList = [...res.data, {
						left: true,
						comment: '',
						code: 'UZS',
						name: 'Наличными',
						currencyId: 26,
						currencyRateId: null,
						paymentTypeCode: 'CASH',
						paymentTypeId: 60,
						id: 60,
						value: 0
					}]
				})
		},
		async openChangePaymentTypeModal(item, paymentItem = null) {
			if (this.paymentTypeList.length === 0) {
				await this.fetchPaymentTypeList();
			}
			await ApiService.get(`/sale/get/${item.id}`).then(res => {
				let saleData = {...item, ...res.data};
				this.selectedSaleForPayment = saleData;
				this.selectedPaymentItemForChange = paymentItem;

				let currentTypeId = null;
				if (paymentItem && paymentItem.paymentTypeId) {
					currentTypeId = paymentItem.paymentTypeId;
				} else if (saleData.payments && saleData.payments.length > 0) {
					currentTypeId = saleData.payments[0].paymentTypeId;
				}

				if (currentTypeId) {
					let found = this.paymentTypeList.find(p => p.id === currentTypeId || p.paymentTypeId === currentTypeId);
					this.newPaymentTypeSelected = found || null;
				} else {
					this.newPaymentTypeSelected = null;
				}

				this.$refs.changePaymentTypeModal.show();
			}).catch(err => {
				this.$vs.notify({
					title: err.message || 'Ошибка при получении данных продажи',
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			});
		},
		closeChangePaymentTypeModal() {
			this.$refs.changePaymentTypeModal.hide();
			this.selectedSaleForPayment = null;
			this.selectedPaymentItemForChange = null;
			this.newPaymentTypeSelected = null;
		},
		async saveNewPaymentType() {
			if (!this.selectedPaymentItemForChange || !this.selectedPaymentItemForChange.id || !this.newPaymentTypeSelected) {
				return;
			}
			this.savingPaymentType = true;
			let targetPaymentTypeId = this.newPaymentTypeSelected.id || this.newPaymentTypeSelected.paymentTypeId;
			let payload = {
				paymentId: this.selectedPaymentItemForChange.id,
				paymentTypeId: targetPaymentTypeId
			};

			try {
				await PosService.updatePaymentType(payload);
				this.$vs.notify({
					title: 'Тип оплаты успешно изменен',
					color: 'success',
					icon: 'check',
					position: 'top-right'
				});
				this.closeChangePaymentTypeModal();
				this.search();
			} catch (err) {
				this.$vs.notify({
					title: err.message || 'Ошибка при изменении типа оплаты',
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			} finally {
				this.savingPaymentType = false;
			}
		}
	},
	computed: {
		...mapState("pos", ["currentSaleWithId"]),
		...mapState("zetReport", ["chechboxId"]),
		...mapState("zetReport", ["zReportById"]),
		...mapState("refunds", ["zReports", "zReportsTotal"]),
		...mapState("contragents", ["contragents"]),
		...mapState(["isCashier", "userDepCurrencyName"]),
		...mapGetters("refunds", ["getSales", "getStatus"]),
		...mapGetters("prices", ["getDepartments"]),
		...mapGetters('departments', [
			'myDepartments'
		]),
		onlyAdmin() {
			let can = false
			if (localStorage.getItem('userName')==='admin'&&localStorage.getItem('developer')==='true')
				can = true
			return can
		},
		itemsForExcel() {
			if (this.getTableItems) {
				if (this.isSales) {
					let array = [];
					let temp;
					this.getTableItems.forEach(el => {
						temp = Object.assign(
							{},
							{
								"Номер чека": el.saleNumber,
								"Дата продажи": el.updateDate,
								Отдел: el.shopName,
								Статус: this.getPaymentStatus(el),
								"Кол-во товаров": el.saleItems
									? el.saleItems.length
									: el.totalCount,
								Сумма: this.getamountOfSumma(el),
								"Сумма со скидкой": this.getamountOfDiscountSumma(el),
								Комментарии: el.comment
							}
						);
						array.push(temp);
					});
					return array;
				}
			}
		},
		saleByItemsForExcel() {
			if (this.salesByItemList) {
				if (this.isSalesByItem) {
					let array = [];
					let temp;
					this.salesByItemList.forEach(el => {
						temp = Object.assign(
							{},
							{
								"Номер чека": el.saleNumber,
								"Дата продажи": el.updateDate,
								Отдел: el.shopName,
								"POS №": el.cashboxName,
								Статус: el.action == 'QAYTARISH'?this.$t('pos.return'):this.$t('sidebar.sales.ready'),
								"Кол-во товаров": el.count,
								Сумма: el.priceUzs,
								"Сумма со скидкой": el.priceAfterUzs,
								Продукт: el.itemName,
								"Спец-код": el.barcode,
								"Штрих-код": el.multiBarcode,
								Артикул: el.artikul
							}
						);
						array.push(temp);
					});
					return array;
				}
			}
		},
		salesFields() {
			return [
				{
					key: "id",
					label: this.$t("users-l.Id"),
					class: "role_id",
					sortable: true,
					visible: true,
					changebale: true
				},
				{
					key: "saleNumber",
					label: this.$t("sale.saleNumber"),
					sortable: true,
					visible: true,
					changebale: true
				},
				{
					key: "updateDate",
					label: this.$t("sale.saleDate"),
					sortable: true,
					thStyle: { width: '12%'}
				},
				{
					key: "shopName",
					label: this.$t("sale.shopName"),
					sortable: true
				},
				{
					key: "cashboxName",
					label: 'POS №',
					sortable: true
				},
				{
					key: "status",
					label: this.$t("sale.status"),
					sortable: true
				},
				{
					key: "itemsCount",
					label: this.$t("sale.transaction-item"),
					sortable: true,
					class: "textAlignCenter"
				},
				{
					key: "amountOfPaymentUzs",
					label: this.$t("pos.sum"),
					sortable: true,
					class: "textAlignCenter"
				},
				{
					key: "amountOfAfterPromoUzs",
					label: this.$t("sale.sum-skidka"),
					sortable: true,
					class: "textAlignCenter"
				},
				// {
				// 	key: 'contragentName',
				// 	label: this.$t('sale.contragent'),
				// 	sortable: true
				// },
				// {
				// 	key: "customerName",
				// 	label: this.$t("sale.client"),
				// 	sortable: true
				// },
				// {
				// 	key: "clientAddress",
				// 	label: "Адрес доставки",
				// 	sortable: true
				// },
				// {
				// 	key: "clientPhoneNumber",
				// 	label: "Контактный номер",
				// 	sortable: true
				// },
				{
					key: "array",
					'class': 'table_actions min-60',
					label: this.$t("Оплата"),
					thStyle: { width: '15%'}
				},
				{
					key: "actions",
					'class': 'table_actions min-60',
					label: this.$t("actions.title")
				}
			];
		},
		zReportsFields() {
			return [
				{
					key: "id",
					label: "ID",
					class: "role_id",
					sortable: true
				},
				{
					key: "startDate",
					label: "Дата начала",
					sortable: true
				},
				{
					key: "endDate",
					label: "Дата окончания",
					sortable: true
				},
				{
					key: "companyDepartmentName",
					label: this.$t("sale.shopName"),
					sortable: true
				},
				{
					key: "zReportStatus",
					label: this.$t("sale.status"),
					sortable: true,
					class: "textAlignCenter"
				},
				{
					key: "actions",
					'class': 'table_actions min-60',
					label: this.$t("actions.title")
				}
			];
		},
		isSales() {
			return this.selected == "sales";
		},
		isSalesByItem() {
			return this.selected == "salesByItem";
		},
		isZReports() {
			return this.selected == "zReports";
		},
		isErrorSales() {
			return this.selected == "errorSales";
		},
		isKorzinka() {
			return this.selected == "korzinka";
		},
		isZReports1() {
			return this.selected == "zReports*";
		},
		getTableItems() {
			return this.isSales ? this.getSales.items : this.zReports;
		},
		computedFields() {
			return this.isSales ? this.salesFields : this.zReportsFields;
		},
		finalTotalEur() {
			let sum = 0
			this.zReportsList.forEach(item => {
				if (item.TOTALEUR)
					sum += item.TOTALEUR
			})
			return sum
		},
		finalTotalUzs() {
			let sum = 0
			this.zReportsList.forEach(item => {
				if (item.TOTALUZS)
					sum += item.TOTALUZS
			})
			return sum
		}
	},
	async created() {
		let userDep = this.myDepartments.find(dep => dep.id == this.userDepId)
		this.zReportDep = userDep ? Object.assign({}, userDep) : null
		await this.fetchCashboxList()
		// departments list
		await this.fetchMyDepartments()
		await this.getDepartmentList();
		await this.getDepartmentsLocal();
		//this.fetchContragents()
		this.loader = false;
	},
	destroyed() {
		this.$store.commit("refunds/resetSales", []);
		this.$store.commit("refunds/resetZReports");
	}
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"/>

<style scoped lang="scss">
	.print {
		display: none;
	}

	@media print {
		// @page {
		// 	size: portrait;
		// }
		.hidden-print {
			display: none;
		}
		.print {
			color: #000000;
			display: block;
		}
		.card {
			box-shadow: none;
		}
	}

	.editBtn {
		font-size: 14px;
		cursor: pointer;
	}

	.filter-frame {
		padding-bottom: 15px;
	}

	.slide-enter,
	.slide-leave-to {
		transform: scaleY(0);
	}

	.certificateGenerate {
		background: transparent !important;
		border: none;
		padding: 7px;
		font-size: 16px;
	}

	.certificateGenerate span {
		margin-left: 5px;
	}

	.top-card {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.search_btn {
		width: 100%;
		display: flex;
		justify-content: flex-end;
		padding-right: 25px;
	}

	input[type="number"]::-webkit-inner-spin-button,
	input[type="number"]::-webkit-outer-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}

	.btn-sml {
		padding: 4px 4px;
		font-size: 9px;
		border-radius: 6px;
	}

	.dropdown-menu {
		font-size: 1px !important;
	}

	.dropdown-item i {
		color: black;
	}

	.card-body {
		padding: 0 !important;
	}

	.spinner-wrapper {
		position: absolute;
		background: rgba(32, 28, 32, 0.49);
		left: 0;
		right: 0;
		text-align: center;
		top: 0;
		bottom: 0;
		padding-top: 35px;
		z-index: 5;
	}

	.table-wrapper {
		position: relative;
		padding: 5px;
	}

	.mx-datepicker {
		width: 290px;
	}
</style>
